import { render } from "./AboutView.vue?vue&type=template&id=60681316&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=60681316&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60681316"]])

export default __exports__